import Chart from "react-apexcharts";

const VeticalBarsChart = ({
  xAxisData,
  yAxisData,
  height,
  width,
  dataName,
}) => {
  const defaultSeries = [{ name: dataName, data: yAxisData }];
  const options = {
    chart: { background: "", toolbar: { show: false } },
    xaxis: {
      categories: xAxisData,
      show: false,
      axisTicks: { show: false },
      axisBorder: { show: false },
      labels: {
        style: {
          colors: "#111", // Set the color of x-axis labels to white
        },
      },
    },
    fill: {
      colors: ["rgba(33, 0, 93, 1)"],
    },
    stroke: { colors: ["rgba(33, 0, 93, 1)"] },
    dataLabels: {
      style: {
        colors: ["rgba(33, 0, 93, 1)", "rgba(33, 0, 93, 1)", "#111"],
      },
    },
    yaxis: { show: false },
    plotOptions: { bar: { borderRadius: 7, columnWidth: 20 } },
    stroke: { width: 0 },
    grid: { show: false },
    tooltip: { enabled: false },
  };
  return (
    <Chart
      options={options}
      series={defaultSeries}
      height={height}
      width={width}
      type="bar"
    />
  );
};

export default VeticalBarsChart;
